import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { ComparisonGraphic, StartComparisonBtn } from 'components/lib/buttons/IconButtons';
import styles from 'styles/components/series/SeriesComparisonChart.css';

const SeriesComparisonLanding = props => (
  <div className={styles.seriesComparisonGraphic}>
    <h1 className={styles.startTitle}>Compare Multiple Series</h1>
    <ComparisonGraphic />
    <div className={styles.outerBorder}>
      <div className={styles.innerBorder}>
        { props.hasData &&
          <StartComparisonBtn onClick={props.toggleSeriesComparisonChart} style={{width: '200px'}} />
        }
      </div>
    </div>
  </div>
)

export default SeriesComparisonLanding;



// WEBPACK FOOTER //
// ./src/scripts/components/series/seriesComparison/SeriesComparisonLanding.js